<template>
  <v-col sm="12" class="overrideCol">
    <div v-show="speedChip !== undefined" id="divtoshow" style="position: absolute; z-index:10;"> <v-chip
      class="ma-2"
      x-small
      color="primary"
    >
      {{ speedChip }} km/h &nbsp;|&nbsp; {{ convertDateShort(speedChipTimestamp) }}
    </v-chip></div>
    <div class="mapWrapper" ref="leafletWrapper" v-bind:class="{ overrideHeight: !fullHeightMap }">
      <l-map
        class="ml-2"
        ref="map"
        :zoom="zoom"
        :max-zoom="maxZoom"
        :center="center"
        :options="mapOptions"
        style="height: 100%;"
      >
        <l-control-layers position="topright"></l-control-layers>

        <l-control position="bottomleft">
          <div v-if="numberOfVehicles > 1 || (routeOptimizationData != null && Object.keys(routeOptimizationData).length != 0)" class="routeHistoryLegend ma-2">
            <v-card class="legendBlock">
              <p class="ml-1">Legenda:</p>
              <v-list>
                <v-list-item-group>
                  <v-list-item
                    v-for="(vehicle, index) in vehiclesForLegend"
                    :key="index"
                    @click="zoomToRoute(vehicle)"
                    class="vehicleListItem"
                  >
                    <v-list-item-title>
                      <v-chip
                        :color="vehicleColors[index]"
                        small
                        class="ml-1"
                        @click="zoomToRoute"
                      >{{ legendSource == 'vehicle' ? vehicle[0].vehicleLabel : vehicle[0].driverName }}</v-chip>
                    </v-list-item-title>
                  </v-list-item>

                   <v-list-item
                    class="vehicleListItem"
                  >
                    <v-list-item-title v-if="routeOptimizationData != null && optimizedRouteForLegend.length > 1">
                      <v-chip
                        color="green"
                        small
                        class="ml-1"
                        @click="zoomToRoute(optimizedRouteForLegend)"
                      >{{ translate('Optimized route', 'realtimeMap') }}</v-chip>
                    </v-list-item-title>
                  </v-list-item>

                </v-list-item-group>
              </v-list>
            </v-card>
          </div>
        </l-control>
        
        <l-tile-layer
          v-for="tile in tileProviders"
          :key="tile.name"
          :visible="tile.visible"
          :url="tile.url"
          :name="tile.name"
          :attribution="tile.attribution"
          layer-type="base"
        />

        <template v-if="showRouteHistory">
          <template v-for="marker in markers">
            <l-marker
              v-if="marker.visible"
              :lat-lng="marker.latLng"
              :key="marker.id"
              :icon="marker.icon"
              class="test"
              @mouseover="openPopup"
            >
              <l-popup :options="leaflet.popup.options">
                <div v-html="marker.content"></div>
              </l-popup>
            </l-marker>
          </template>
        </template>
        
        <template v-if="showRouteHistory">
          <template v-for="(r, index) in routesToShow">
            <l-polyline :lat-lngs="r.latLngs" :weight="6"  :color="r.color" :key="index" @mouseover="info"  @mouseenter="info" @mouseout="resetSpeedChip"></l-polyline>
          </template>
        </template>

        <template v-if="!showRouteHistory">
          <template v-for="(r, index) in privateBusinessDriveRoutesToDisplay">
            <l-polyline :lat-lngs="r.latLngs" :weight="6"  :color="r.color" :key="index"></l-polyline>
          </template>
        </template>

        <div v-if="routeOptimizationData">
          <template v-for="(route,index) in routeOptimizationData.routes">
              <l-polyline 
              :zIndex="index == 0 ? 10 : 0" :lat-lngs="route.coordinates" :key="'optimization' + index" color="green"
          />
          </template>

        </div>

        <template v-for="(r, index) in overSpeedings">
          <l-polyline :lat-lngs="r" color="red" :key="'overspeeding_' + index"></l-polyline>
        </template>
      </l-map>

      <template>
        <v-col> 
          <RouteHistoryResult v-if="tableData && displayTable" :routes="tableData" />
        </v-col>
      </template>
      <template>
        <v-dialog v-model="dialog.show" @keydown.esc="onCloseDialogHandler" max-width="380">
          <template v-if="dialog.show">
            <v-card flat tile>
              <BaseDialogTitle @close="onCloseDialogHandler">
                <template v-slot:title>{{labels.poiDetails}}</template>
              </BaseDialogTitle>
              <v-card-text>
                <MapCrudComponent
                  mapType="leaflet"
                  :mapData="mapCrudData"
                  @closeMapCrudComponent="handleMapCrudComponentClose"
                  :submited="dialog.submited"
                  :closed="!dialog.show"
                  @resetSubmit="dialog.submited=false"
                ></MapCrudComponent>
              </v-card-text>
              <v-card-actions>
                <SubmitGroup
                  @close="onCloseDialogHandler"
                  :closeOnSubmit="closeOnSubmit"
                  @submit="onSubmitDialogHandler"
                />
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </template>
    </div>
  </v-col>
</template>

<script>
import { MultiOptionsPolyline } from 'Leaflet.MultiOptionsPolyline'
import { getRoutesGroupedBy } from '../../../utils/map/routesGroupedBy'
import { mapState } from 'vuex'
import { latLng } from 'leaflet'
import EventBus from '../../../event-bus'
import options from '../../../resource/maps/leafletOptions'
import BaseLeafletMapComponent from '../BaseLeafletMapComponent'
import Vue from 'vue'
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LControl,
  LControlLayers,
  LPolyline
} from 'vue2-leaflet'
import LDraw from 'leaflet-draw'
import store from '@/store/store'
import translate from '@/utils/genTable/multilanguageHelper.js'
import formatDate from '@/utils/formatDateHelper.js'

export default {
  name: 'LeafletRouteHistoryComponent',
  extends: BaseLeafletMapComponent,
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LDraw,
    LControlLayers,
    LControl,
    LPolyline,
    LPolygon: () => import('vue2-leaflet'),
    LCircle: () => import('vue2-leaflet'),
    RouteHistoryResult: () =>
      import('@/components/map/route/RouteHistoryResult')
  },
  data() {
    return {
      speedChip: undefined,
      speedChipTimestamp: undefined,
      overSpeedings: [],
      routesToShow: [],
      zoom: null,
      maxZoom: null,
      center: null,
      tileProviders: [],
      mapOptions: {
        zoomSnap: null
      },
      markers: [],
      vehiclesForLegend: [],
      arrowsFeatureGroup: [],
      multiPolyline: [],
      routeDataLoaded: false,
      showMapLegend: false,
      singleRoute: { route: null, markers: [] },
      numberOfVehicles: 0,
      firstMarkers: [],
      lastMarkers: [],
      labels: {
        time: translate('Time', 'realtimeMap'),
        stopDuration: translate('Stop duration', 'realtimeMap'),
        number: translate('Number', 'realtimeMap'),
        driver: translate('Driver Name', 'realtimeMap'),
        vehicleLabel: translate('Vehicle Label', 'realtimeMap'),
        incidentName: translate('Incident name', 'realtimeMap'),
        incidentValue: translate('Incident value', 'realtimeMap'),
        pois: translate('Poi', 'realtimeMap'),
        speed: translate('Speed', 'realtimeMap')
      },
      leaflet: {
        popup: {
          options: {
            maxWidth: 450,
            maxHeight: 200
          }
        }
      },
      optimizedRouteForLegend: [],
      privateBusinessDriveRoutesToDisplay: [],
      showRouteHistory: true
    }
  },
  created() {
    let { zoom, maxZoom, zoomSnap, center, tileProviders } = options
    this.zoom = zoom
    this.maxZoom = maxZoom
    this.center = latLng(center.lat, center.lng)
    this.tileProviders = tileProviders
    this.mapOptions.zoomSnap = zoomSnap
  },
  mounted() {
    EventBus.$on(
      'ROUTE_HISTORY_SHOW_SELECTED_ROW_POSITION_ON_MAP',
      this.handleRouteHistorySelectedRow
    )
    var that = this
    EventBus.$on('ROUTE_HISTORY_GO_TO_START', function() {
      that.zoomToRoute([that.routes[0]])
    })

    EventBus.$on('ROUTE_HISTORY_GO_TO_END', function() {
      that.zoomToRoute([that.routes[that.routes.length - 1]])
    })
  },
  computed: {
    ...mapState('history', [
      'routes',
      'maxSpeed',
      'fullHeightMap',
      'tableData',
      'routeSegment',
      'vehicleColors',
      'displayRouteDirections',
      'legendSource',
      'displayTable',
      'searchObject',
      'routeOptimizationData',
      'privateDriveRoutes',
      'businessDriveRoutes'
    ]),
    speedThresholds() {
      if (this.maxSpeed) {
        return [
          this.maxSpeed,
          this.maxSpeed * 1.2,
          this.maxSpeed * 1.4,
          this.maxSpeed * 1.5,
          this.maxSpeed * 1.8,
          this.maxSpeed * 2
        ]
      }

      return []
    }
  },
  methods: {
    info(route) {
      var left = route.containerPoint.x - 10 + 'px'
      var top = route.containerPoint.y - 35 + 'px'

      var div = document.getElementById('divtoshow')

      div.style.left = left
      div.style.top = top

      var point = new window.L.latLng(
        this.conv(route.latlng.lat),
        this.conv(route.latlng.lng)
      )

      for (let route of this.routesToShow) {
        for (let i = 0, j = 1; j < route.latLngs.length; i++, j++) {
          var first = route.latLngs[i]
          var second = route.latLngs[j]
          if (!first || !second) {
            break
          }

          var line = window.L.polygon([
            [first[0] - 0.00009, first[1]],
            [first[0] + 0.00009, first[1]],
            [second[0] + 0.00009, second[1]],
            [second[0] - 0.00009, second[1]]
          ])

          if (line.getBounds().contains(point)) {
            this.speedChip = first[2]
            this.speedChipTimestamp = route.timestamps[i]
            break
          }
        }
      }
    },
    conv(coordinate) {
      var beforePoint = coordinate.toString().split('.')[0]
      var afterPoint = coordinate
        .toString()
        .split('.')[1]
        .substr(0, 6)

      let newCoordinate = beforePoint + '.' + afterPoint
      return Number(newCoordinate)
    },
    showArrow() {
      if (this.displayRouteDirections) {
        this.arrowsFeatureGroup.forEach(layer => {
          this.$refs.map.mapObject.addLayer(layer)
        })
      } else {
        this.arrowsFeatureGroup.forEach(layer => {
          this.$refs.map.mapObject.removeLayer(layer)
        })
      }
    },
    removeSelectedMarker(map) {
      if (this.selectedMarker) {
        this.markers = this.markers.filter(item => item !== this.selectedMarker)
        map.removeLayer(this.selectedMarker)
        this.selectedMarker = null
      }
    },
    drawSigngleRoute(data) {
      const map = this.$refs.map.mapObject
      //const singleRoute = null
      const startTime = Date.parse(data.route.startPoint.time)
      const stopTime = Date.parse(data.route.stopPoint.time)
      var points = this.routePolyline
        .map(p => {
          return { lat: p.lat, long: p.lng, time: Date.parse(p.meta.time) }
        })
        .filter(y => y.time >= startTime && y.time <= stopTime)
      this.removeSelectedMarker(map)
      if (this.singleRoute.route) {
        this.removeSingleRoute(map)
      }
      //Draw route
      const routePolyline = []
      points.forEach(coord => {
        routePolyline.push({
          lat: coord.lat,
          lng: coord.long
        })
      })
      this.singleRoute.route = window.L.polyline(routePolyline, {
        weight: 5,
        opacity: 1,
        color: '#9C27B0'
      }).addTo(map)
      map.fitBounds(this.singleRoute.route.getBounds())
      //Draw markers
      data.markers.forEach(coord => {
        const marker = window.L.marker([coord.latitude, coord.longitude])
        this.singleRoute.markers.push(marker)
        marker.addTo(map)
      })
    },
    removeSingleRoute(map) {
      if (this.singleRoute.route) {
        this.singleRoute.route.remove(map)
      }

      this.singleRoute.markers.forEach(marker => {
        map.removeLayer(marker)
        marker = null
      })
      this.singleRoute.markers = []
    },
    handleRouteHistorySelectedRow(data) {
      const map = this.$refs.map.mapObject
      if (this.singleRoute.route) {
        this.removeSingleRoute(map)
      }
      // Filter out all previous markers with source 'route-history'
      this.markers = this.markers.filter(
        marker => marker.source != 'route-history'
      )
      data.markers.forEach(marker => {
        var color = 'bluecar'
        if (marker.speed) {
          color = 'greencar'
        } else if (!marker.isVehicleTurnedOn) {
          color = 'redcar'
        }
        const selectedMarker = {
          id: `Imei ${marker.imei + marker.latitude + Math.random()}`,
          latLng: latLng(marker.latitude, marker.longitude),
          content: `
            <p class="leafletParagraf">${this.labels.driver}: ${
            marker.driverName
          }</p>
            <p class="leafletParagraf">${this.labels.speed}: ${
            marker.speed
          } km/h</p>
            <p class="leafletParagraf">${this.labels.vehicleLabel}: ${
            marker.vehicleLabel
          }</p>
            <p class="leafletParagraf">${this.labels.time}: ${
            this.convertDate(marker.timestamp)
          }</p>
          `,
          visible: true,
          source: 'route-history',
          icon: this.getCustomMarkerIcon('truck.png', color, 30, 30)
        }
        this.selectedMarker = selectedMarker
        this.markers.push(selectedMarker)
        //1. nacin
        //const latLngs = [[marker.latitude, marker.longitude]]
        // var markerBounds = L.latLngBounds(latLngs)
        // map.fitBounds(markerBounds)
        //2. nacin
        const latLngs = latLng(marker.latitude, marker.longitude)
        map.setView([latLngs.lat, latLngs.lng], 50)
      })
    },
    openPopup: function(event) {
      Vue.nextTick(() => {
        event.target.openPopup()
      })
    },
    getCustomMarkerIcon(icon, iconColor, sizeX, sizeY) {
      return L.icon({
        iconUrl: `${process.env.VUE_APP_S3_DOMAIN}/icons/${icon}`,
        iconSize: [sizeX, sizeY],
        iconAnchor: [20, 20],
        className: iconColor
      })
    },
    handleRouteChange(routeData) {
      let routes = routeData
      /**
       * Empty all polylines and markers from previouse requests.
       */
      this.markers = []
      this.vehiclesForLegend = []
      this.routesToShow = []
      this.overSpeedings = []

      var that = this

      this.arrowsFeatureGroup = []

      this.multiPolyline.forEach(layer => {
        that.$refs.map.mapObject.removeLayer(layer)
      })
      this.firstMarkers.forEach(firstMarker => this.$refs.map.mapObject.removeLayer(firstMarker))
      this.lastMarkers.forEach(lastMarker => this.$refs.map.mapObject.removeLayer(lastMarker))
      this.firstMarkers = []
      this.lastMarkers = []

      /**
       * Group routes that are returned from API, by their `IMEI`.
       */
      var routesGroupedByImeis
      if (this.searchObject.VehicleIds) {
        routesGroupedByImeis = getRoutesGroupedBy(routeData, 'imei')
      } else {
        routesGroupedByImeis = getRoutesGroupedBy(routeData, 'driverName')
      }
      /**
       * We will use this Array to zoom our map and fit all routes.
       */
      var allRoutes = []
      var counter = 0
      this.numberOfVehicles = 0
      routesGroupedByImeis.forEach(imeiRoutes => {
        /**
         * Temp. variables for data manupilation.
         */
        var preparedCoordinates = []
        var stoppedMarkers = []
        var routePolyline = []
        var routesPerImei = []

        this.vehiclesForLegend.push(imeiRoutes)

        imeiRoutes.forEach(route => {
          allRoutes.push([route.latitude, route.longitude])
          routesPerImei.push([route.latitude, route.longitude])
          preparedCoordinates.push([route.latitude, route.longitude])

          routePolyline.push({
            lat: route.latitude,
            lng: route.longitude,
            speed: route.speed,
            meta: {
              time: route.timestamp
            }
          })
          this.routePolyline = []
          //Casse that vehicle is changed and single route is previus loaded
          if (this.singleRoute.route) {
            this.removeSingleRoute(this.$refs.map.mapObject)
            this.singleRoute = { route: null, markers: [] }
          }

          this.routePolyline = routePolyline

          if (!route.isMoving) {
            // If there is more than 1 vehicle selected, we need to reset counter
            var found = stoppedMarkers.find(sm => sm.imei == route.imei)

            if (!found) {
              counter = 0
            }

            stoppedMarkers.push({
              lat: route.latitude,
              lng: route.longitude,
              time: route.timestamp,
              imei: route.imei,
              number: counter + 1,
              stopDuration: route.stopDuration
            })
            counter++
          }
        })

        this.firstAndLastRouteHistoryMarkers(routesPerImei)

        this.moveStoppagesSlightlyApartIfTheyAreTooClose(stoppedMarkers)

        stoppedMarkers.forEach(x => {
          var stoppedMarker = window.L.divIcon({
            className: 'stopped-marker',
            bgPos: [5, 5],
            html: `<div class="pin-letter"><span><b>${x.number}</b></span></div>`
          })
          this.markers.push({
            id: `Imei ${x.lat + Math.random()}`,
            latLng: latLng(x.lat, x.lng),
            content: `
              <p class="leafletParagraf">${this.labels.number}: ${x.number}</p>
              <p class="leafletParagraf">${this.labels.stopDuration}: ${
              x.stopDuration
            }</p>
              <p class="leafletParagraf">${this.labels.time}: ${this.convertDate(x.time)}</p>
            `,
            icon: stoppedMarker,
            visible: true
          })
        })

        this.routesToShow.push({
          latLngs: routePolyline.map(x => [x.lat, x.lng, x.speed]),
          timestamps: routePolyline.map(x => x.meta.time),
          color: this.vehicleColors[this.numberOfVehicles]
        })

        this.numberOfVehicles++

        let overSpeedings = []
        for (let route of imeiRoutes) {
          if (route.allowedSpeed && route.speed > route.allowedSpeed) {
            overSpeedings.push({
              lat: route.latitude,
              lng: route.longitude
            })
          } else {
            if (overSpeedings.length) {
              this.overSpeedings.push(overSpeedings.map(o => [o.lat, o.lng]))
            }
            overSpeedings = []
          }
        }
      })

      if (this.numberOfVehicles > 1) {
        this.showMapLegend = true
      }

      if (allRoutes.length) {
        this.zoomToRoute(routes)
      }
      store.dispatch('history/isDrawing', false)
    },
    handleRouteOptimization(routeOptimizationData) {
      if(routeOptimizationData) {
        for (const route of routeOptimizationData.routes) {
          route.coordinates.forEach(coordinate => this.optimizedRouteForLegend.push({latitude: coordinate[0], longitude: coordinate[1]}))
        }
        this.zoomToRoute(this.optimizedRouteForLegend);
      }
    },
    handlePrivateBusinessDriveChange() {
      this.privateBusinessDriveRoutesToDisplay = []
      let privateBusinessArray = []

      if(this.searchObject.privateDrive && this.searchObject.businessDrive) {
        privateBusinessArray = this.privateDriveRoutes.concat(this.businessDriveRoutes)
      } else if (this.searchObject.privateDrive) {
        privateBusinessArray = this.privateDriveRoutes
      } else if (this.searchObject.businessDrive) {
        privateBusinessArray = this.businessDriveRoutes
      }

      if(this.searchObject.privateDrive || this.searchObject.businessDrive) {
        privateBusinessArray.forEach(route => {
          let routeObj = {}
          routeObj.latLngs = []
          
          if(route[0].ioEventName == 'Privatna') {
            routeObj.color = '#F44336'            
          } else if (route[0].ioEventName == 'Službena') {
            routeObj.color = '#3F51B5'
          }
          route.forEach(point => {
            routeObj.latLngs.push([point.latitude, point.longitude, point.speed])
          })
          this.privateBusinessDriveRoutesToDisplay.push(routeObj)
        })
        this.showRouteHistory = false
        this.firstMarkers.forEach(firstMarker => this.$refs.map.mapObject.removeLayer(firstMarker))
        this.lastMarkers.forEach(lastMarker => this.$refs.map.mapObject.removeLayer(lastMarker))
      } else {
        this.showRouteHistory = true
        if(this.firstMarkers && this.firstMarkers.length) {
          this.firstMarkers.forEach(firstMarker => firstMarker.addTo(this.$refs.map.mapObject))
        }
        if(this.lastMarkers && this.firstMarkers.length) {
          this.lastMarkers.forEach(lastMarker => lastMarker.addTo(this.$refs.map.mapObject))
        }
      }
    },
    translate(engText, translatePath) {
      return translate(engText, translatePath)
    },
    resizeMap() {
      if (this.fullHeightMap) {
        this.$refs.leafletWrapper.classList.remove('overrideHeight')
      } else {
        this.$refs.leafletWrapper.classList.add('overrideHeight')
      }
      this.$refs.map.mapObject.invalidateSize()
    },
    firstAndLastRouteHistoryMarkers(allRoutes) {
      var firstIcon = window.L.divIcon({
        className: 'first-icon',
        bgPos: [5, 5],
        html: `<div class='pin firstPin'></div>`
      })

      var lastIcon = window.L.divIcon({
        className: 'first-icon',
        bgPos: [5, 5],
        html: `<div class='pin lastPin'></div>`
      })

      var firstPoint = allRoutes[0]
      var lastPoint = allRoutes[allRoutes.length - 1]

      var diff = Math.abs((firstPoint[0] + firstPoint[1]) - (lastPoint[0] + lastPoint[1]))

      if (diff < 0.0001) {
        lastPoint[1] += 0.0002
      }

      let firstMarker = window.L.marker(firstPoint, {
        icon: firstIcon
      }).addTo(this.$refs.map.mapObject)
      this.firstMarkers.push(firstMarker)

      let lastMarker = window.L.marker(lastPoint, {
        icon: lastIcon
      }).addTo(this.$refs.map.mapObject)
      this.lastMarkers.push(lastMarker)
    },
    convertDate(date) {
      return formatDate(date, 'long', true)
    },
    convertDateShort(date) {
      if (!date) {
        return ''
      }
      return formatDate(date, 'medium', true)
    },
    resetSpeedChip() {
      this.speedChip = undefined
      this.speedChipTimestamp = undefined
    },
    moveStoppagesSlightlyApartIfTheyAreTooClose(stoppedMarkers) {
      var groups = this.groupBy(stoppedMarkers, x => Math.floor((x.lat + x.lng ) / 0.0001) )

      groups.forEach(g => {
        if (g.length > 1) {
          let increment = 0

          g.forEach(x => {
            x.lng += increment
            increment += 0.0002
          })
        }
      })
    },
    groupBy(list, keyFunction) {
      const result = {}

      list.forEach(x => {
        let index = keyFunction(x)
        result[index] = (result[index] || []).concat(x)
      });

      return Object.keys(result).map(x => result[x])
    }
  },
  watch: {
    routes: {
      handler() {
        this.handleRouteChange(this.routes)
        this.handleRouteOptimization(this.routeOptimizationData)
      }
    },
    fullHeightMap: {
      handler() {
        this.resizeMap()
      }
    },
    routeSegment: {
      handler() {
        this.drawSigngleRoute(this.routeSegment)
      }
    },
    displayRouteDirections: {
      handler() {
        this.showArrow()
      }
    },
    searchObject: {
      deep: true,
      handler() {
        this.handlePrivateBusinessDriveChange()
      }
    }
  }
}
</script>

<style src="leaflet/dist/leaflet.css">
</style>
<style src="../../../assets/icons.css">
</style>
<style>
.vue2leaflet-map {
  z-index: 1 !important;
}
.legendBlock {
  padding: 10px;
  padding-bottom: 5px;
}
.vehicleListItem {
  margin-bottom: 15px;
}
.legendBlock p {
  margin-bottom: 10px;
}
</style>
